class ArticleShare extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.addEventListener('click', async (event) => {
      if (!event.target.closest('[data-copy]')) return;
      const status = this.querySelector('[role="status"]');
      try {
        await navigator.clipboard.writeText(this.dataset.url);
        status.textContent = this.dataset.success;
      } catch {
        status.textContent = this.dataset.failure;
        const fallback = this.querySelector('input');
        fallback.hidden = false;
        fallback.focus();
        fallback.select();
      }
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('s-article-share')) customElements.define('s-article-share', ArticleShare);
